import { useTheme } from "@amx/ux-twoui-theming";
import { Stack } from "@fluentui/react";
import React, { useEffect } from "react";
import { validateChildComponent } from "../../../shared/validation";
import { validDetailsAreas, validHighlightAreas } from "./ExpandedFeatureGroupContent.helpers";
import { getHighlightAreaStyles } from "./ExpandedFeatureGroupContent.styles";

export interface ExpandedFeatureGroupContentProps {
    /**
     * Highlight area at the top of the ExpandedFeatureGroupContent.
     */
    readonly highlightArea?: React.ReactNode | readonly React.ReactNode[];
    /**
     * Details area at the bottom of the ExpandedFeatureGroupContent.
     */
    readonly detailsArea?: React.ReactNode | readonly React.ReactNode[];
}

export const ExpandedFeatureGroupContent: React.FC<ExpandedFeatureGroupContentProps> = ({
    highlightArea,
    detailsArea
}) => {

    const theme = useTheme();

    useEffect(() => {
        if (highlightArea) {
            if (Array.isArray(highlightArea)) {
                for (let index = 0; index < highlightArea.length; index++) {
                    validateChildComponent(highlightArea[index], validHighlightAreas, "ExpandedFeatureGroupContent");
                }
            } else {
                validateChildComponent(highlightArea, validHighlightAreas, "ExpandedFeatureGroupContent");
            }
        }
    }, [highlightArea]);

    useEffect(() => {
        if (detailsArea) {
            if (Array.isArray(detailsArea)) {
                for (let index = 0; index < detailsArea.length; index++) {
                    validateChildComponent(detailsArea[index], validDetailsAreas, "ExpandedFeatureGroupContent");
                }
            } else {
                validateChildComponent(detailsArea, validDetailsAreas, "ExpandedFeatureGroupContent");
            }
        }
    }, [detailsArea]);

    return (
        <Stack>
            {highlightArea && (
                <Stack styles={getHighlightAreaStyles(theme, !!detailsArea)}>
                    {highlightArea}
                </Stack>
            )}
            {detailsArea && (
                <Stack>
                    {detailsArea}
                </Stack>
            )}
        </Stack>
    );
};
